import React, { useEffect, useState } from 'react'
import {
  Heading,
  Form,
  FieldGroup,
  Label,
  Textarea
} from './styles'
import { makePostMissionAnswer, makePutMissionAnswer } from '../../../../main/usecases/mission-answer/post-mission-answer-factory'
import { setTeam } from '../../../utils/team_helpers'
import { useGame, useGameWrapper } from '../../../contexts'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { Instructions, Container, Image } from '../styles'
import { getLocalStorage, removeLocalStorage } from '../../../utils/storage_helpers'
import { addAllowFullScreen } from '../../../utils/mission_helpers'
import { t } from '../../../adapters/translate/translate'
import { replaceHtmlEntity } from '../../../utils/text_replace'

const TeamNameMission = () => {
  const [teamName, setTeamName] = useState('')
  const { currentMission, submitCallback, doSubmit, submitButtonIsEnabled, handleToggleStatusSubmitButton, setTimePaused } = useGameWrapper()
  const [color, setColor] = useState<any>('#fff')
  const { game } = useGame()

  async function sendAnswer () {
    try {
      const res = await makePostMissionAnswer().post({
        mission: currentMission?.uuid,
        answer: [teamName.replace(/\n/g, ' ')],
        team: { name: teamName.replace(/\n/g, ' ') }
      })
      setTeam(res?.team)
      if (getLocalStorage('passwordTemp') && res?.team?.id) {
        const passwordData = JSON.parse(getLocalStorage('passwordTemp') || '')

        const resPost = await makePostMissionAnswer().post({
          mission: passwordData?.uuid,
          team: res?.team?.id
        })

        await makePutMissionAnswer(resPost['@id'] || '').update({
          answer: [{ description: passwordData?.password }],
          status: 'responded'
        })
        removeLocalStorage('passwordTemp')
      }
      return res
    } catch (error) {
      console.error('TeamNameMission.sendAnswer', error)
    }
  }

  function handleEnableButton () {
    if (teamName.trim().length === 0) {
      handleToggleStatusSubmitButton(false)
    } else {
      handleToggleStatusSubmitButton(true)
    }
  }

  useEffect(() => {
    handleEnableButton()
  }, [teamName])

  useEffect(() => {
    if (doSubmit && submitButtonIsEnabled) {
      submitCallback(sendAnswer)
    }
  }, [doSubmit])

  useEffect(() => {
    setTimePaused(false)
    if (game) { setColor(game?.textColor || '#fff') }
  }, [game])

  useEffect(() => {
    const div = document.getElementById('instructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [])

  return (
    <Container justify="center">
      <Heading>
        { currentMission?.icon && <Image src={getAssetUrl('icon', String(currentMission?.icon))} /> }
        {!!currentMission && <Instructions id="instructions" dangerouslySetInnerHTML={
          { __html: addAllowFullScreen(currentMission?.instructions) }
        } />}
      </Heading>

      <Form>
        <FieldGroup>
          <Label style={{ color }}>{t('Register below')}</Label>
          <Textarea
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setTeamName(e.target.value)}
            value={teamName}
            placeholder={`${t('Enter here')}...`}
          />
        </FieldGroup>
      </Form>
    </Container>
  )
}

export default TeamNameMission
